// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "رمز الخطأ:",
    "error.search": "ابحث في قاعدة معلوماتنا لمعرفة المزيد",
    dismiss: "تجاهل",
    "installation.title": "",
    "cancelation.button": "إلغاء",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "فشل التمهيد",
      description: "تعذر عرض الصفحة. يُرجى الاتصال بقسم الدعم.",
    },
    "EOS-UI-UE": {
      title: "هناك خطأ ما.",
      description: "هناك خطأ ما. يُرجى الاتصال بقسم الدعم.",
    },
    "EOS-IN-BC": {
      title: "فشل التثبيت",
      description: "لم نتمكن من إظهار تقدم التثبيت. يُرجى الاتصال بقسم الدعم.",
    },
    "EOS-IN-UE": {
      title: "فشل التثبيت",
      description: "هناك خطأ ما. يُرجى الاتصال بقسم الدعم.",
    },
    "EOS-IN-FF": {
      title: "فشل التثبيت",
      description:
        "لم نتمكن من الاتصال بـ Epic Online Services. يُرجى الاتصال بقسم الدعم.",
    },
    "EOS-IN-FF-*": {
      title: "فشل التثبيت",
      description:
        "لم نتمكن من إرسال الطلب إلى Epic Online Services. يُرجى الاتصال بقسم الدعم.",
    },
    fallback: {
      title: "هناك خطأ ما.",
      description: "هناك خطأ ما. يُرجى الاتصال بقسم الدعم.",
    },
  },
};
